<template>
  <HeaderViewDesktop
    v-if="windowWidth >= 1320"
    :animation-enabled="animationEnabled"
    :display-logo="displayLogo"
  />
  <HeaderViewMobile
    v-else
    :animation-enabled="animationEnabled"
    :display-logo="displayLogo"
    :is-mobile-menu-open="isMobileMenuOpen"
    @update-window-size="$emit('header-resize', $event)"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import HeaderViewDesktop from './header-view-desktop';
import HeaderViewMobile from './header-view-mobile';

export default {
  props: {
    animationEnabled: {
      type: Boolean,
      default: true,
    },
    displayLogo: {
      type: Boolean,
      default: true,
    },
    isMobileMenuOpen: {
      type: Boolean,
      required: true,
    },
  },
  components: { HeaderViewDesktop, HeaderViewMobile },
  computed: {
    ...mapGetters('layoutModule', ['windowWidth']),
  }
};
</script>
